<template lang="jade">
  div.Input(v-bind:class="{'Input--filled': !empty || active, 'Input--invalid': error, 'Input--valid': complete }"
            ":skin"="skins.inputs")
    div.Input__field(class="Input__field--stripe")
      div(":id"="type")
    label.Input__label
      span.Input__label-content
        span.Input__icon {{ type | splitCamelCaseToString }}
</template>

<script>
  import _ from 'lodash'
  import {skins} from 'src/vuex/getters'

  export default {
    data () {
      return {
        error: false,
        complete: false,
        empty: true,
        brand: '',
        value: undefined,
        active: false
      }
    },
    props: {
      type: {
        type: String,
        required: true
      },
      elements: {
        required: true
      },
      attr: {
        type: Object,
        required: true
      }
    },
    filters: {
      splitCamelCaseToString (str) {
        let text = str.split(/(?=[A-Z])/)
        return _.map(text, xs => xs.charAt(0).toUpperCase() + xs.slice(1)).join(' ')
      }
    },
    vuex: {
      getters: {
        skins
      }
    },
    ready () {
      let props = ['fontFamily', 'fontSize', 'lineHeight', 'color', 'fontWeight']
      let computedStyles = getComputedStyle(document.querySelector('.Input__field'), null)

      let input = this.elements.create(this.type, {
        style: {
          base: _.assign(_.pick(computedStyles, props), {'::placeholder': {color: '#fff'}})
        }
      })
      this.$set('attr.element', input)
      input.mount(`#${this.type}`)
      input.on('change', e => {
        _.forIn(e, (v, k) => {
          this.$set(k, v)
        })
      })
      input.on('focus', e => {
        this.$set('active', true)
      })
      input.on('blur', e => {
        this.$set('active', false)
      })
    }
  }
</script>


// WEBPACK FOOTER //
// element.vue?49340ca1